const ufeApi = require('services/api/ufeApi');


// https://jira.sephora.com/wiki/display/ILLUMINATE/Auto+Login+API

function autoLogin(_body = {}) {
    const url = '/api/ssi/autoLogin';
    return ufeApi.makeRequest(url, {
        method: 'POST',
        credentials: 'include',
        headers: { 'Content-type': 'application/json' },
        body: JSON.stringify(_body)
    }).then(data => data.errorCode ? Promise.reject(data) : data);
}


module.exports = { autoLogin };
